export const currencySearchFunction = (option, input) => {
  const uniInput = input.toUpperCase();
  const uniCode = option.value.toUpperCase();
  const uniLabel = option.label.props.children[1].toUpperCase();

  return uniCode.includes(uniInput) || uniLabel.includes(uniInput);
};
